import cx from 'classnames';
import StarIcon from 'static/svgs/icon/star-icon';
import css from './styles/guide-hero.module.css';
import starCSS from './styles/guide-hero-stars.module.css';
import UniversitiesMarquee from './universities-marquee';

type GuideHeroProps = {
  header: string;
  imgSrc: string;
  imgAlt: string;
};

const GuideHero: React.FC<React.PropsWithChildren<GuideHeroProps>> = (
  props,
) => {
  return (
    <div className={css.wrapper}>
      <div className={css.hero}>
        <Left {...props} />
        <Right imgSrc={props.imgSrc} imgAlt={props.imgAlt} />
      </div>
      <UniversitiesMarquee />
    </div>
  );
};

const Left: React.FC<React.PropsWithChildren<GuideHeroProps>> = ({
  header,
  imgSrc,
  imgAlt,
  children,
}) => (
  <div className={css.left}>
    <div className={css.textContainer}>
      <div className={starCSS.mobileWrapper}>
        <StarIcon shadow className={starCSS.mobileTop} />
      </div>
      <div className={css.label}>Guide</div>
      <h1 className={css.header}>{header}</h1>
      <MobileImage imgSrc={imgSrc} imgAlt={imgAlt} />
      <div className={css.description}>{children}</div>
      <div className={starCSS.mobileWrapper}>
        <StarIcon shadow className={starCSS.mobileBottom} />
      </div>
    </div>
  </div>
);

const MobileImage: React.FC<
  React.PropsWithChildren<Omit<GuideHeroProps, 'header'>>
> = ({ imgSrc, imgAlt }) => (
  <div className={cx(css.mobileImage, starCSS.mobileWrapper)}>
    <img src={imgSrc} alt={imgAlt} />
    <StarIcon shadow className={starCSS.mobileMiddle} />
  </div>
);

const Right: React.FC<
  React.PropsWithChildren<Omit<GuideHeroProps, 'header'>>
> = ({ imgSrc, imgAlt }) => (
  <div className={css.right}>
    <div className={starCSS.wrapper}>
      <StarIcon shadow className={starCSS.topLeft} />
      <StarIcon shadow className={starCSS.topRight} />
    </div>
    <img src={imgSrc} alt={imgAlt} />
    <div className={starCSS.wrapper}>
      <StarIcon shadow className={starCSS.bottomRight} />
      <StarIcon shadow className={starCSS.bottomLeft} />
    </div>
  </div>
);

export default GuideHero;
